import CartIcon from '../../components/icons/CartIcon';
import CrossIcon from '../../components/icons/CrossIcon';
import DeleteIcon from '../../components/icons/DeleteIcon';
import PencilIcon from '../../components/icons/PencilIcon';
import PriceCell from '../../components/price-cell/PriceCell';
import { Body, BodyBold } from '../../components/Typography';
import { Box, Button, styled, Typography } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../../components/FlexContainers';
import { palette } from '../../theme/palette';

export const WrapperContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const CartButtonWrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const CartButton = styled(CartIcon)`
  color: ${palette.custom.white};
  display: block;
  pointer-events: none;
`;

export const Count = styled(Box)`
  border-radius: 50%;
  background-color: ${palette.custom.darkGrey};
  color: white;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 10px;
  opacity: 1;
  transition: opacity 0.2s ease 0.4s;

  @media (min-width: 992px) {
    #esp-links-menu-container:has(#es-search-autosuggest.desktop:focus-within) & {
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }
`;

export const PopoverWrapper = styled(Box)`
  box-sizing: border-box;
  border-radius: 5px;
  background: ${palette.custom.white};
  padding: 14px 16px 24px 16px;
`;

export const StyledPopover = styled(Box)`
  width: 95vw;
  max-width: 400px;
  position: absolute;
  top: 68px;
  right: -10px;
  z-index: 100;
  box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
`;

export const ArrowContainer = styled(Box)`
  position: absolute;
  top: -20px;
  right: 10px;
`;

export const Arrow = styled(Box)`
  width: 40px;
  height: 21px;
  position: relative;
  overflow: hidden;
  :after {
    content: '';
    position: absolute;
    width: 30px;
    height: 30px;
    background: ${palette.custom.white};
    transform: rotate(45deg);
    top: 8px;
    left: 5px;
    border-radius: 5px 0 0 0;
    box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.15);
  }
`;

export const Header = styled(Typography)`
  color: ${palette.custom.darkGrey};
  font-size: 20px;
  font-style: normal;
  font-weight: 800;
  line-height: 38px;
  letter-spacing: 0.25px;
  text-transform: capitalize;
`;

export const CartItemsContainer = styled(VFlex)`
  margin-top: 18px;
  overflow-y: auto;
  gap: 20px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-top: 22px;
    max-height: 333px;
  }
`;

export const CartHeaderItem = styled(Box)`
  display: flex;
  gap: 14px;
  padding-right: 10px;
`;

export const CartItemImageWrapper = styled(Box)`
  padding-top: 2px;
  display: flex;
  align-items: center;
`;

export const CartItemImage = styled('img')`
  max-width: unset;
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

export const CartItemDetailsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-right: 5px;
`;

export const CartItemName = styled(Typography)`
  color: ${palette.custom.darkGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;

  &:hover {
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.down('xs')} {
    line-height: 20px;
  }
`;

export const CartItemSelectedDates = styled(Typography)`
  color: ${palette.custom.mediumDarkGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.35px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    line-height: 20px;
  }
`;

export const CartItemUpdateContainer = styled(Box)`
  margin-left: auto;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  gap: 9px;
`;

export const StyledPencilIcon = styled(PencilIcon)`
  width: 20px;
  height: 20px;
  object-fit: contain;
  color: ${palette.primary.main};
  cursor: pointer;
`;

export const StyledDeleteIcon = styled(DeleteIcon)`
  width: 18px;
  height: 20px;
  object-fit: contain;
  color: ${palette.primary.main};
  cursor: pointer;
`;

export const DateSummaryContainer = styled(Box)`
  display: flex;
  background: rgba(238, 238, 238, 0.5);
  border-radius: 5px;
  padding: 12px 16px;
  margin-top: 20px;
  gap: 16px;
`;

export const DateSummaryItem = styled(Typography)`
  font-size: 14px;
  color: ${palette.custom.greyBorder};
  line-height: 20px;
  flex: 1;

  &:last-child {
    text-align: right;
  }
`;

export const DateSummaryLabel = styled('span')`
  font-weight: 700;
`;

export const DateSummaryValue = styled('span')`
  font-weight: 400;
`;

export const EstimatedTotalContainer = styled(Box)`
  display: flex;
  margin-top: 25px;
  justify-content: space-between;
`;

export const EstimatedTotalLabel = styled(Typography)`
  color: ${palette.custom.darkGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.35px;
`;

export const EstimatedTotal = styled(PriceCell)`
  margin-left: auto;
  .price-cell-typography {
    color: ${palette.custom.darkGrey};
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.35px;
  }
`;

export const CheckoutButton = styled(Button)`
  width: 100%;
  margin-top: 16px;
  height: 40px;
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  background: ${palette.primary.main};
  color: ${palette.custom.white};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background-color: ${palette.primary.main};
  }
`;

export const ContinueShoppingButton = styled(Button)`
  width: 100%;
  margin-top: 11px;
  height: 40.152px;
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  color: ${palette.custom.darkGrey};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    background-color: ${palette.custom.white};
  }
`;

export const BrowseEquipmentButton = styled(CheckoutButton)`
  margin-top: 25px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    margin-top: 18px;
  }
`;

export const DropdownMenu = styled(Box)`
  background: ${palette.custom.white};
  border-radius: 5px;
  display: grid;
  gap: 0px;
  grid-template-areas: 'AreaOne AreaOne' 'AreaThree AreaTwo' 'AreaFour AreaFour';
  grid-template-columns: minmax(auto, 215px) minmax(auto, 133px);
  grid-template-rows: auto;
  width: 100%;
  box-shadow: 0px 4px 6px 0px #0000001a;

  ${(props) => props.theme.breakpoints.down('xs')} {
    grid-template-areas: 'AreaOne' 'AreaTwo';
    grid-template-columns: auto;
    max-width: unset;
    border-radius: 0px 0px 5px 5px;
  }
`;

export const AreaOne = styled(Box)`
  grid-area: AreaOne;
  position: relative;
  width: 100%;

  ${(props) => props.theme.breakpoints.down('xs')} {
    background: ${palette.custom.darkGrey};
    display: flex;
    align-items: center;
    height: 71px;
  }
`;

export const CartItemsInfoWrapper = styled(HFlex)`
  align-items: flex-start;
  background: ${palette.custom.darkGrey};
  border-radius: 6px;
  gap: 32px;
  justify-content: space-between;
  min-height: 38px;
  padding: 12px 12px 12px 12px;
  margin: 17px 26px 10px 26px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    background: none;
    padding: 0;
    align-items: center;
    margin: 0px 20px;
    width: 100%;
  }
`;

export const CartItemsInfo = styled(HFlex)`
  align-items: flex-start;
  gap: 10px;
  ${(props) => props.theme.breakpoints.down('xs')} {
    align-items: center;
  }
`;

export const CartLabel = styled(Body)`
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.025em;
  line-height: 14px;
  margin-bottom: 0px;
  white-space: nowrap;
  ${(props) => props.theme.breakpoints.down('xs')} {
    font-family: trade-gothic-next-condensed, sans-serif;
    font-size: 20px;
    font-weight: ${fontWeight.heavy};
    color: ${palette.custom.white};
    text-transform: uppercase;
  }
`;

export const CartItemsLabel = styled(BodyBold)`
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.25px;
  margin-bottom: 0px;
  word-break: break-word;
  color: ${palette.custom.white};

  ${(props) => props.theme.breakpoints.down('xs')} {
    font-size: 16px;
    font-weight: ${fontWeight.light};
    color: ${palette.custom.white};
  }
`;

export const CloseButton = styled(Box)`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${palette.primary.main};
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;

export const AreaTwo = styled(VFlex)`
  grid-area: AreaTwo;
  position: relative;
  padding: 9px 10px 10px 17px;

  ${(props) => props.theme.breakpoints.down('xs')} {
    padding: 0px 20px 25px 20px;
  }
`;

export const BrowseSelectionLabel = styled(Box)`
  margin-top: 18px;
  color: ${palette.custom.darkGrey};
  font-size: 12px;
  font-style: normal;
  font-weight: ${fontWeight.regular};
  line-height: 20px;
  text-transform: capitalize;
`;
